const STEP_TYPE = {
  GAME: 'game',
  ACTION: 'action',
  EREADER: 'ereader',
  VOCAB: 'vocab',
};
export default STEP_TYPE;
